<template>
  <div class="tableMask"
       v-if="questions">
    <div class="anList">
      <div class="antitle">
        <h3 style="text-align:center;">参考答案及评分标准</h3>
      </div>
      <div class="anbody">
        <div v-for="(elem, index) of questions"
             :key="index"
             class="answerItem">
          <h3 class="">{{ elem.showSerialNum }}、{{ elem.viewTypeName }}
            <span v-if="elem.quesTypeDesc">{{elem.quesTypeDesc}}</span>
          </h3>
          <ul v-if="elem.list && elem.list.length>0">
            <li v-for="(item, idx) of elem.list"
                :key="idx"
                class="item">
              <!-- 大题 -->
              <div v-if="elem.quesTypeID==4 || elem.quesTypeID==5">
                <div>{{idx + 1}}.<span v-if="item.additionalContent"
                        v-html="item.additionalContent"></span></div>
                <!-- 大题有子题 -->
                <div v-if="item.smallContent && item.smallContent.length>0">
                  <div v-for="(itm, i) of item.smallContent"
                       :key="i"
                       class="item">
                    <div v-html="'('+(i+1)+')'+itm.content"></div>
                    <div v-html="itm.answer"></div>
                  </div>
                </div>
                <!-- 大题没子题 -->
                <div v-else>
                  <div>{{idx + 1}}.<span v-if="item.additionalContent"
                          v-html="item.additionalContent"></span></div>
                  <span v-html="item.answer"></span>
                  <span v-if="item.analysis"
                        v-html="' 依据：' + item.analysis"></span>
                </div>
              </div>
              <div v-else>
                {{idx + 1}}.
                <span v-html="item.answer"></span>;
                <span v-if="item.analysis"
                      v-html="' 依据：' + item.analysis"></span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="anfooter">
        <a href="javascript:void(0)"
           class="an"
           @click="closeTable">关闭</a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'QuesAnswerList',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['questions']),
  },
  mounted() {
    if (this.questions) {
      //console.log('==', this.questions)
    }
  },
  methods: {
    closeTable() {
      this.$emit('toggleTable', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.answerItem {
  > h3 {
    margin: 8px 0;
    font-size: 18px;
  }
  ul li {
    font-size: 16px;
    line-height: 1.6;
  }
  .item {
    margin-bottom: 10px;
  }
}
</style>
